@if(counter > 0) {
<div class="container-fluid loader_container">
    <div class="dashboard-wrapper">
        <div class="loader">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
        </div>
    </div>
</div>
}